import generateAsyncActions from 'utils/generateAsyncActions';
import alt from 'components/Dispatcher';
import CoachingStatsSource from 'sources/coaching/CoachingStatsSource';

class CoachingStatsActions {
  constructor() {
    this.generateActions(...generateAsyncActions('coachingStats'));
  }
  coachingStats(planId) {
    return dispatch => {
      dispatch(planId);
      return CoachingStatsSource.getCoachingStats(planId).then(
        this.coachingStatsSuccess,
        this.coachingStatsError
      );
    };
  }
}

export default alt.createActions(CoachingStatsActions);
